import { useMemo } from 'react';

/**
 * Ambient hearts drifting upward, like petals on still water. Used on the
 * login screen and on the unlock celebration. Density is capped — anything
 * past ~10 simultaneous animations crosses from "atmosphere" into "screensaver."
 */
interface Props {
  density?: number;
  duration?: [number, number];
  className?: string;
}

export function FloatingHearts({ density = 5, duration = [14, 22], className }: Props) {
  const items = useMemo(() => {
    return Array.from({ length: density }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * duration[1],
      dur: duration[0] + Math.random() * (duration[1] - duration[0]),
      size: 12 + Math.random() * 18,
      hue: ['var(--c-blush)', 'var(--c-peach)', 'var(--c-lavender)'][i % 3],
      tilt: Math.random() * 20 - 10,
    }));
  }, [density, duration]);

  return (
    <div aria-hidden className={className} style={{
      position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none',
    }}>
      {items.map((h) => (
        <svg key={h.id} viewBox="0 0 24 24" width={h.size} height={h.size}
          style={{
            position: 'absolute', left: `${h.left}%`, bottom: '-40px',
            animation: `float ${h.dur}s linear ${h.delay}s infinite`,
            opacity: 0,
            transform: `rotate(${h.tilt}deg)`,
            filter: 'drop-shadow(0 2px 4px rgba(196,150,164,0.20))',
          }}>
          <path
            d="M12 20.5c-2.2-1.5-7.5-4.6-9.2-9.0C1.4 7.4 3.6 4 7 4c1.9 0 3.7 1 5 2.5C13.4 5 15.2 4 17.1 4c3.3 0 5.6 3.5 4.4 7.1C19.7 16 14.4 19 12 20.5z"
            fill={h.hue} stroke="var(--c-rose-deep)" strokeWidth="1.2" strokeLinejoin="round" opacity="0.9"
          />
        </svg>
      ))}
    </div>
  );
}
